import intl from 'react-intl-universal';
import { useState } from 'react';
import { message, Space, Spin, Modal } from 'antd';
import Icon from '../Icon';

import { getTextByEncryp } from '@/api/common';
import useCall from '@/hooks/useCall';
import { isGlobalEnv } from '@/config';
import SmsForm from '@/components/Sms/components/SmsForm';

interface Props {
    type: number;
    text: string;
    secret?: string;
    showCall?: boolean; // 是否展示拨打电话
    showSMS?: boolean; // 是否展示发送短信
    extraParams?: {
        sourceNo?: string;
        [key: string]: any;
    };
}

/**
 * 
 * ORDER_DETAIL_CUSTOMER_PHONE(1, "订单详情-客户信息-当前使用手机号", ""),
ORDER_DETAIL_RECEIVE_INFO_PHONE(2, "订单详情-收货信息-电话", ""),
ORDER_DETAIL_RECEIVE_INFO_ADDRESS(3, "订单详情-收货信息-地址", ""),

CUSTOMER_DETAIL_CUSTOMER_PHONE(4, "客户详情-当前使用手机号", ""),

AFTER_SALE_DETAIL_CUSTOMER_PHONE(5, "售后详情-客户信息-当前使用手机号", "客户信息-当前使用手机号"),
AFTER_SALE_DETAIL_RECEIVE_INFO_PHONE(6, "售后详情-收货信息-电话", "收货信息-电话"),
AFTER_SALE_DETAIL_RECEIVE_INFO_ADDRESS(7, "售后详情-收货信息-地址", "收货信息-地址"),
AFTER_SALE_DETAIL_PICK_UP_INFO_PHONE(8, "售后详情-退货信息-电话", "退货信息-电话"),
AFTER_SALE_DETAIL_PICK_UP_INFO_ADDRESS(9, "售后详情-退货信息-地址", "退货信息-地址"),

WORK_ORDER_DETAIL_CUSTOMER_PHONE(10, "工单详情-客户信息-当前使用手机号", "客户信息-当前使用手机号"),

SOURCE_ORDER_INFO_FOR_CREATE_EXCHANGE(11, "创建换货-原订单信息", ""),
SOURCE_ORDER_INFO_FOR_CREATE_REPAIR(12, "创建维修-原订单信息", ""),
SOURCE_ORDER_INFO_FOR_CREATE_ACCESSORY(13, "创建补发配件-原订单信息", ""),
SOURCE_ORDER_INFO_FOR_CREATE_REFUND(14, "创建退货退款-原订单信息", ""),

AFTER_SALE_DETAIL_FOR_UPDATE_RECEIVER_INFO(15, "售后详情编辑-原订单信息-收货信息", ""),
AFTER_SALE_DETAIL_FOR_UPDATE_PICK_UP_INFO(16, "售后详情编辑-原订单信息-退货信息", ""),

IM_CUSTOMER_PHONE(17, "IM-用户资料-当前使用手机号", "IM-用户资料-当前使用手机号"),
 * 
 */

const PrivacyField: React.FC<Props> = ({
    type,
    text,
    secret,
    showCall = false,
    showSMS = false,
    extraParams,
}) => {
    const [isShowLigth, setIsShowLight] = useState<boolean>(false);
    const [lightString, setLightString] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [isShowSMSModal, setIsShowModal] = useState<boolean>(false);
    const { call } = useCall();

    const onShowlight = (isCall = false) => {
        if (!type) {
            message.error(intl.get('请指定当前查看位置信息'));
            return;
        }
        if (!secret) {
            message.error(intl.get('当前字段不支持查看明文'));
            return;
        }
        setLoading(true);
        // FIX: 请求接口
        console.log('-=-=extraParams', extraParams);

        getTextByEncryp({
            type,
            encryptList: [secret],
            ...extraParams,
        })
            .catch((err) => {
                setLoading(false);
                return Promise.reject(err);
            })
            .then((res) => {
                setLoading(false);
                if (res.code === 0) {
                    if (isCall) {
                        Modal.confirm({
                            title: intl.get('您是否要发起外呼'),
                            onOk: () => {
                                call(res.data[0], {
                                    workOrderNo: extraParams?.sourceNo,
                                });
                            },
                        });
                    } else {
                        setLightString(res.data[0]);
                        setIsShowLight(true);
                    }
                } else {
                    message.error(res.message);
                }
            });
    };

    const onSendSms = () => {
        console.log('-=-=发送短信', text, secret);
        setIsShowModal(true);
    };
    return (
        <span>
            {isShowLigth ? lightString || '--' : text || '-'}
            <Space style={{ marginLeft: 5 }}>
                {loading && <Spin />}
                {!loading && !isShowLigth && secret && (
                    <Icon
                        type="icon-yanjing"
                        style={{ color: '#09f', fontSize: 16 }}
                        onClick={() => onShowlight()}
                    ></Icon>
                )}
                {text && showCall && !isGlobalEnv && (
                    <Icon
                        type="icon-gongdanxiangqingwaihu"
                        style={{ color: '#09f' }}
                        onClick={() => onShowlight(true)}
                    ></Icon>
                )}
                {text && showSMS && !isGlobalEnv && (
                    <Icon
                        type="icon-fasongduanxin"
                        style={{ color: '#09f' }}
                        onClick={() => onSendSms(true)}
                    ></Icon>
                )}
            </Space>

            <SmsForm
                open={isShowSMSModal}
                type="single"
                title={intl.get('发送短信')}
                phone={text}
                params={{
                    workOrderNo: extraParams?.sourceNo,
                    mobileEncrypt: secret,
                }}
                onCancel={() => setIsShowModal(false)}
            />
        </span>
    );
};

export default PrivacyField;
